import { FC } from 'react';
import { AllieFilterBarDesktopV2 } from './FilterBarV2.desktop';
import { AllieFilterBarMobileV2 } from './FilterBarV2.mobile';

export interface FilterV2 {
  label: string;
  getOptions?: (labelAll: string) => { text: string; value: string }[];
  component?: React.ReactNode;
  handleChange: (e: any) => void;
  selected: string | number | number[] | string;
  disabled?: boolean;
  multiple?: boolean;
  interfaceOptions?: any;
}

export interface FilterBarPropsV2 {
  filters: FilterV2[];
  labelAll: string;
  labelMultiple?: string;
  labelFilterBy?: string;
  isDesktop?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const AllieFilterBarV2: FC<FilterBarPropsV2> = ({ isDesktop, ...props }) => {
  const FilterBarPlatform = isDesktop ? AllieFilterBarDesktopV2 : AllieFilterBarMobileV2;

  return <FilterBarPlatform {...props} />;
};
